<!--
 * @Author: your name
 * @Date: 2020-11-11 21:00:06
 * @LastEditTime: 2020-12-25 17:09:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/home/themelist/index.vue
-->
<template>
  <!-- 主题清单列表 -->
  <div>
    <title-bar-back :title="'清单详情'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="theme_bg">
      <div
        class="theme_title font_weight400 font22 line_height_30 colof text_left"
      >
        {{ queryRetailStoreThemeDetail.title }}
      </div>
      <theme-product
        v-for="(item, index) in queryRetailStoreThemeDetail.details"
        :key="index"
        :product="item"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import ThemeProduct from "./components/ThemeProduct";
export default {
  name: "ThemeList",
  components: {
    TitleBarBack,
    ThemeProduct
  },
  data() {
    return {};
  },
  computed: {
    queryRetailStoreThemeDetail() {
      return this.$store.getters.queryRetailStoreThemeDetail;
    }
  },
  watch: {
    queryRetailStoreThemeDetail: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true
    }
  },
  mounted() {
    this.getData();
    // console.log(this.queryRetailStoreThemeDetail);
  },
  methods: {
    back() {
      this.$router.back();
    },
    getData() {
      const params = { slug: this.slug, id: this.$route.query.id };
      this.$store
        .dispatch("home/queryRetailStoreThemeDetail", {
          params
        })
        .then(() => {})
        .catch(() => {});
    },
    goDetail(id) {
      this.$router.push({
        path: "/product/detail",
        query: {
          id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title_right {
  width: 36px;
}
.theme_bg {
  background-image: url("../../../assets/home/theme_bg_det.png");
  background-size: 100% 132px;
  background-repeat: no-repeat;
  .theme_title {
    padding: 25px 0 25px 12px;
  }
}
</style>
